'use strict';

var _ = require('lodash');
function HostShareService(ConfigurationService) {
  var getHostShare = function getHostShare(market, pos) {
    var hostShares = ConfigurationService.getHostShare();
    var marketHostShare = [];
    _.forEach(hostShares, function (hostShare) {
      if (market.origin === hostShare.origin && market.destination === hostShare.destination && hostShare.significantPOS === pos.spos) {
        marketHostShare.push(hostShare);
      }
    });
    return marketHostShare;
  };
  var loadHostShare = function loadHostShare(market, pos) {
    var shares = getHostShare(market, pos);
    var groupedShares = _.groupBy(shares, 'dayOfWeek');
    _.forEach(pos.marketShare.data, function (day) {
      day.dayOfWeek = day.dayOfWeek.toUpperCase();
      var dow = day.dayOfWeek;
      if (groupedShares[dow]) {
        day.share = Math.round(groupedShares[dow][0].hostShare * 10000) / 100;
        day.hostShare = Math.round(groupedShares[dow][0].hostShare * 10000) / 100;
        day.origin = groupedShares[dow][0].origin;
        day.destination = groupedShares[dow][0].destination;
        day.significantPOS = groupedShares[dow][0].significantPOS;
        day.hepKey = groupedShares[dow][0].hepKey;
      }
    });
    return pos;
  };
  return {
    loadHostShare: loadHostShare
  };
}
HostShareService.$inject = ['ConfigurationService'];
module.exports = HostShareService;